import { FaStar } from "react-icons/fa";

type StarRatingProps = {
    rating: number;
    maxRating?: number;
    size?: number;
    color?: string;
    secondaryColor?: string;
};

export const StarRating = ({
    rating,
    maxRating = 5,
    size = 16,
    color = "#FFD700",
    secondaryColor = "#CCCCCC",
}: StarRatingProps) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating - fullStars >= 0.5;

    const stars = [];

    for (let i = 0; i < maxRating; i++) {
        if (i < fullStars) {
            stars.push(
                <FaStar
                    key={i}
                    size={size}
                    color={color}
                    className="inline-block"
                />,
            );
        } else if (i === fullStars && hasHalfStar) {
            stars.push(
                <div
                    key={i}
                    className="relative inline-block"
                    style={{ width: size, height: size }}
                >
                    <FaStar
                        size={size}
                        color={secondaryColor}
                        className="absolute"
                    />
                    <div
                        className="absolute overflow-hidden"
                        style={{
                            width: `${((rating - fullStars) * 100).toFixed(0)}%`,
                        }}
                    >
                        <FaStar size={size} color={color} />
                    </div>
                </div>,
            );
        } else {
            stars.push(
                <FaStar
                    key={i}
                    size={size}
                    color={secondaryColor}
                    className="inline-block"
                />,
            );
        }
    }

    return <div className="flex items-center">{stars}</div>;
};
